import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { LOGO_URL, COMPANY, NAV_LINKS } from "@/lib/siteData";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-navy text-slate-200 mt-24"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div
          className="absolute -top-32 -right-20 w-[420px] h-[420px] rounded-full blur-3xl opacity-25"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, #6366f1, transparent 60%)",
          }}
        />
        <div
          className="absolute -bottom-24 -left-10 w-[360px] h-[360px] rounded-full blur-3xl opacity-20"
          style={{
            background:
              "radial-gradient(circle at 50% 50%, #ec4899, transparent 60%)",
          }}
        />
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <div className="bg-white inline-block rounded-md p-3">
              <img
                src={LOGO_URL}
                alt={COMPANY.name}
                className="h-28 w-auto object-contain"
                data-testid="footer-logo"
              />
            </div>
            <div className="flex flex-col leading-tight">
              <span className="font-display text-3xl font-bold uppercase tracking-tight text-white">
                RPG Rasayan
              </span>
              <span className="text-sm uppercase tracking-[0.2em] text-slate-400">
                Udyog Ltd
              </span>
            </div>
          </div>
          <p className="mt-5 text-slate-300 text-sm leading-relaxed max-w-md">
            Manufacturer of high-performance plasticisers (DOTP, DOP, DINP
            and TOTM) — backed by our parent company's 50 years of chemical
            manufacturing expertise, catering to multiple industries across
            India with same-day dispatch.
          </p>
        </div>

        <div className="md:col-span-3">
          <h4 className="font-display uppercase text-white text-sm tracking-widest mb-4">
            Explore
          </h4>
          <ul className="space-y-2">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase()}`}
                  className="text-sm text-slate-300 hover:text-white transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-4">
          <h4 className="font-display uppercase text-white text-sm tracking-widest mb-4">
            Contact
          </h4>
          <ul className="space-y-3 text-sm text-slate-300">
            <li className="flex items-start gap-3">
              <MapPin size={16} className="mt-0.5 shrink-0 text-indigo-300" />
              <span data-testid="footer-address">{COMPANY.address}</span>
            </li>
            <li className="flex items-center gap-3">
              <Phone size={16} className="shrink-0 text-indigo-300" />
              <span data-testid="footer-phone">{COMPANY.phone}</span>
            </li>
            <li className="flex items-center gap-3">
              <Mail size={16} className="shrink-0 text-indigo-300" />
              <a
                href={`mailto:${COMPANY.email}`}
                className="hover:text-white transition-colors"
                data-testid="footer-email"
              >
                {COMPANY.email}
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-slate-400" data-testid="footer-copyright">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <p className="text-xs text-slate-500 uppercase tracking-widest">
            Eastern India · Plasticisers · Same-Day Delivery · Pan-India
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
